/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import List, { ItemDragging } from 'devextreme-react/list';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.dark.css';

interface ListWithRowDragProps<T extends unknown> {
  keyExpr: keyof T;
  itemTemplate: React.ReactElement | React.FC | React.ReactNode;
  data?: T[];
  onDataChange?: (dataList: T[]) => void;
  disabled?: boolean;
  datasource?: string;
}

export const ListWithItemDrag = <T extends unknown>({
  keyExpr,
  itemTemplate,
  data = [],
  datasource = 'datasource',
  onDataChange = () => {},
  disabled = false,
}: ListWithRowDragProps<T>): JSX.Element => {
  const [innerData, setInnerData] = useState<T[]>([]);

  const onReorder = (e: any) => {
    const updatedArray = [...data];
    updatedArray.splice(e.fromIndex, 1);
    updatedArray.splice(e.toIndex, 0, data[e.fromIndex]);
    onDataChange(updatedArray);
  };

  return (
    <List
      onContentReady={() => setInnerData(data)}
      repaintChangesOnly
      selectionMode="none"
      dataSource={innerData}
      keyExpr={keyExpr as string}
      itemRender={itemTemplate as any}
      showScrollbar="never"
      disabled={disabled}
    >
      <ItemDragging
        allowReordering={!disabled}
        data={datasource}
        onReorder={onReorder}
        dragDirection="vertical"
        rtlEnabled
      />
    </List>
  );
};
